module.exports = __webpack_public_path__ + "img/AMIGA.9b984e6e.png";